module.exports = __webpack_public_path__ + "img/logo_odisys.0129cc9b.png";